<!-- 메인 -->
<template>
    <div class="home">
        <section class="ban" style="background-color: #fff;">
            <div class="container">
                <Carousel :value="bannerItems" :numVisible="1" :numScroll="1" :autoplayInterval="5000">
                    <template #item="slotProps">
                        <div class="banBox">
                            <div class="imgBox">
                                <img :src="slotProps.data.banimg" alt="배너"/>
                            </div>
                            <div class="righttxtBox" >
                                <h1 class="" v-html="slotProps.data.tit"></h1>
                                <p v-html="slotProps.data.txt"></p>
                            </div>
                        </div>
                    </template>
                </Carousel>
            </div>
        </section>

        <section class="sec1" style="padding-top: 0;">
            <div class="tit">
                <h1>We are Aidsoft</h1>
                <p>소프트웨어의 진정한 강자, 에이드소프트와 같이 하세요</p>
            </div>
            <div class="content container">
                <div>
                    <img src="@/assets/img/weareicon1.png" alt="최고의 전문 개발진">
                    <div class="txtbox">
                        <b>최고의 전문 개발진</b>
                        <p>10년 이상의 실무 경력자로 <br> 구성되어 있습니다.</p>
                    </div>
                </div>

                <div>
                    <img src="@/assets/img/weareicon2.png" alt="고객 맞춤형 개발">
                    <div class="txtbox">
                        <b>고객 맞춤형 개발</b>
                        <p>고객과의 상담을 통해 <br> 고객에 가장 적합한 솔루션 제공</p>
                    </div>
                </div>

                <div>
                    <img src="@/assets/img/weareicon3.png" alt="다양한 플랫폼 서비스 지원">
                    <div class="txtbox">
                        <b>다양한 플랫폼 서비스 지원</b>
                        <p>웹/모바일 / 윈도우 소프트웨어/ <br> 클라우드 소프트웨어 개발이 가능 합니다.</p>
                    </div>
                </div>

                <div>
                    <img src="@/assets/img/weareicon4.png" alt="전문 소프트웨어 개발">
                    <div class="txtbox">
                        <b>전문 소프트웨어 개발</b>
                        <p>IOT 개발 / 동영상 미디어/ <br> 클라우드 소프트웨어를 수년간의 <br> 개발 노하우로 직접 개발해 드립니다.</p>
                    </div>
                </div>
            </div>
        </section>

        <section class="bg">
            <div class="tit">
                <h1>사업 소개</h1>
                <p>에이드소프트는 혁신적인 IT 구축 서비스를 제공하는 선도적인 기업입니다. <br> 우리의 주요 사업분야는 다음과 같습니다.</p>
            </div>
            <div class="content container">
                <div class="businessBox">
                    <div class="row">
                        <div class="imgarea">
                            <div class="imgBox"><img src="@/assets/img/business_img1.png" alt="웹 소프트웨어"></div>
                            <router-link to="/webmob" class="txtBox">
                                <sub>WEB</sub>
                                <h3>웹(모바일웹)</h3>
                                <p>다양한 비즈니스의 맞춤형 웹 소프트웨어를 전문적으로 개발 해드립니다.</p>
                                <i class="pi pi-arrow-right" ></i>
                            </router-link>
                        </div>
                        <router-link to="/iot" class="txtBox">
                            <h3>IOT 서비스​</h3>
                            <p>IOT 장비 소프트웨어 및 IOT Edge ​대규모 IOT 장비 운영 플랫폼 및 분석 서비스를 전문적으로 개발 하고 있습니다.</p>
                            <i class="pi pi-arrow-right" ></i>
                        </router-link>
                    </div>
                    <div class="row">
                        <router-link to="/mobileapp" class="txtBox">
                            <sub>APP</sub>
                            <h3>모바일 앱</h3>
                            <p>안드로이드,아이폰, 모바일 등 각 플랫폼에 맞추어 소프트웨어를 개발 해드립니다.</p>
                            <i class="pi pi-arrow-right" ></i>
                        </router-link>
                        <div class="imgarea">
                            <div class="imgBox"><img src="@/assets/img/business_img3.png" alt="미디어 플랫폼 구축 / 개발​">
                            </div>
                            <router-link to="/video" class="txtBox">
                                <h3>동영상 미디어 서비스​</h3>
                                <p>온라인 기반의 동영상 (VOD/Live) 플랫폼 구축 및 전문적인 개발 해드립니다.</p>
                                <i class="pi pi-arrow-right" ></i>
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="imgarea">
                            <div class="imgBox"><img src="@/assets/img/business_img2.png" alt="비즈니스 소프트웨어"></div>
                            <router-link to="/poskiosk" class="txtBox">
                                    <h3>POS/Kiosk</h3>
                                    <p>키오스크, POS, 비즈니스 소프트웨어 등 전문적으로 소프트웨어 개발 해드립니다.</p>
                                    <i class="pi pi-arrow-right" ></i>
                            </router-link>
                        </div>
                        <router-link to="/customSoftware" class="txtBox">
                            <h3>맞춤형 소프트웨어​</h3>
                            <p>10년 이상의 개발 경력을 지닌 팀이 다양한 고객 맞춤형 프로젝트의 기획/설계/개발/운영을 해드립니다.</p>
                            <i class="pi pi-arrow-right" ></i>
                        </router-link>
                    </div>
                </div>
            </div>
        </section>

        <section style="padding-bottom: 0;">
            <div class="tit">
                <h1>에이드소프트 솔루션</h1>
                <p>에이드소프트는 최고의 기술력을 바탕으로 혁신적인 IT솔루션을 제공합니다.</p>
            </div>
            <div class="aidsoulBox container">

                <div>
                    <img src="@/assets/img/aidsoul_img2.png" alt="클래스나옴">
                    <div class="txtbox">
                        <h3>"학습의 새로운 기준, 클래스나옴!”</h3>
                        <p>클래스나옴은 직관적인 LMS 솔루션으로 <br>
                            학습 관리와 데이터 분석을 간편하게 제공합니다.</p>
                        <p>개인 맞춤형 학습 환경과 모바일 친화적 기능으로<br>
                            교육의 혁신을 경험하세요.</p>
                        <p>이 문구를 통해 두 솔루션의 핵심 가치를 <br>
                            간결하고 효과적으로 전달할 수 있습니다.</p>
                    </div>
                </div>

                <div>
                    <img src="@/assets/img/aidsoul_img1.png" alt="온마이스">
                    <div class="txtbox">
                        <h3>"온라인 행사의 모든 것을 한곳에서!"</h3>
                        <p>온마이스는 실시간 화상회의, 가상 부스, <br>
                            라이브 스트리밍 등​ 온라인 행사 운영에 필요한 <br>
                            모든 기능을 제공하는 올인원 플랫폼입니다. </p>
                        <p>효율적인 행사 준비와 성공적인 결과를 <br>
                            만들어드립니다.</p>
                        <a href="https://www.onmice.co.kr" target="_blank">https://www.onmice.co.kr</a>
                    </div>
                </div>

            </div>
        </section>

        <section class="pf_sec" style="padding-bottom: 0;">
            <div class="tit">
                <h1>Portfolio</h1>
            </div>
            <div class="content container">
                <!-- <Tabs value="0">
                    <TabList>
                        <Tab value="0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                viewBox="0 0 20 20" fill="none">
                                <mask id="mask0_1236_204" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0"
                                    y="0" width="20" height="20">
                                    <rect width="20" height="20" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_1236_204)">
                                    <path
                                        d="M4.42247 17.0846C4.00817 17.0846 3.65352 16.9371 3.35852 16.6421C3.06352 16.3471 2.91602 15.9925 2.91602 15.5782V10.418H8.54102V17.0846H4.42247ZM9.79102 17.0846V10.418H17.0827V15.5782C17.0827 15.9925 16.9352 16.3471 16.6402 16.6421C16.3452 16.9371 15.9905 17.0846 15.5762 17.0846H9.79102ZM2.91602 9.16797V4.42443C2.91602 4.01012 3.06352 3.65547 3.35852 3.36047C3.65352 3.06547 4.00817 2.91797 4.42247 2.91797H15.5762C15.9905 2.91797 16.3452 3.06547 16.6402 3.36047C16.9352 3.65547 17.0827 4.01012 17.0827 4.42443V9.16797H2.91602Z"
                                        fill="#4F4F4F" />
                                </g>
                            </svg>
                            전체
                        </Tab>
                        <Tab value="1">웹/모바일</Tab>
                        <Tab value="2">IOT 서비스</Tab>
                        <Tab value="3">온라인 미디어 플랫폼</Tab>
                        <Tab value="4">소프트웨어</Tab>
                        <Tab value="5">온라인전시</Tab>
                    </TabList>
                    <TabPanels>
                
                        <TabPanel value="0">
                            <div class="pfWrap">
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/webmob/portfolio1.png" alt="비상벨 지도형 서비스">
                                </div>
                                    <div class="pfBox">
                                    <img src="@/assets/img/pf/webmob/portfolio2.png" alt="식품 컨설팅">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/webmob/portfolio3.png" alt="전통 문화 연구회">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/iot/portfolio1.png" alt="관리 프로그램">
                                </div>
                                    <div class="pfBox">
                                    <img src="@/assets/img/pf/iot/portfolio2.png" alt="물류 서비스">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/iot/portfolio3.png" alt="생산기술원 관리">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/onlinemedia/portfolio1.png" alt="클라우드 LMS서비스">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/onlinemedia/portfolio2.png" alt="동물보건사 교육 서비스">

                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/onlinemedia/portfolio3.png" alt="대한수의사회 UI">
                                </div>
                            </div>
                        </TabPanel>
    
                        <TabPanel value="1">
                            <div class="pfWrap">
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/webmob/portfolio1.png" alt="비상벨 지도형 서비스">
                                </div>
                                    <div class="pfBox">
                                    <img src="@/assets/img/pf/webmob/portfolio2.png" alt="식품 컨설팅">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/webmob/portfolio3.png" alt="전통 문화 연구회">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/webmob/portfolio4.png" alt="포켓 와이파이">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/webmob/portfolio5.png" alt="유심 판매 솔루션">
                                </div>
                            </div>
                        </TabPanel>
    
                        <TabPanel value="2">
                                <div class="pfWrap">
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/iot/portfolio1.png" alt="관리 프로그램">
                                </div>
                                    <div class="pfBox">
                                    <img src="@/assets/img/pf/iot/portfolio2.png" alt="물류 서비스">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/iot/portfolio3.png" alt="생산기술원 관리">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/iot/portfolio4.png" alt="생산기술원 관리">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/iot/portfolio5.png" alt="농장 AI 모니터링 시스템">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/iot/portfolio6.png" alt="로봇 모니터링 시스템">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/iot/portfolio7.png" alt="디지털 영상 운영 솔루션">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/iot/portfolio8.png" alt="디지털 사이니지">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/iot/portfolio9.png" alt="맨홀 모니터링 시스템">
                                </div>
                            </div>
                        </TabPanel>
                        
                        <TabPanel value="3">
                            <div class="pfWrap">
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/onlinemedia/portfolio1.png" alt="클라우드 LMS서비스">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/onlinemedia/portfolio2.png" alt="동물보건사 교육 서비스">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/onlinemedia/portfolio3.png" alt="대한수의사회 UI">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/onlinemedia/portfolio4.png" alt="클라우드 수술 영상 판매">
                                </div>
                            </div>
                        </TabPanel>
                
                        <TabPanel value="4">
                            <div class="pfWrap">
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/software/portfolio1.png" alt="대표 매장 POS">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/software/portfolio2.png" alt="포켓 와이파이 프로그램">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/software/portfolio3.png" alt="디지털 교육 솔루션">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/software/portfolio4.png" alt="금영 엔터테이먼트 POS">
                                </div>
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/software/portfolio5.png" alt="무인 호텔 예약 POS">
                                </div>
                            </div>
                        </TabPanel>
                    
                        <TabPanel value="5">
                            <div class="pfWrap">
                                <div class="pfBox">
                                    <img src="@/assets/img/pf/onlineexhibtion/portfolio1.png" alt="정선군">
                                </div>
                            </div>
                        </TabPanel>
                    </TabPanels>
                </Tabs> -->

                <div class="pfWrap">
                    <div class="pfBox">
                        <router-link to="/portfolio/view/736zc01mmp6rg8z">
                            <img src="@/assets/img/pf/webmob/portfolio1.png" alt="비상벨 지도형 서비스">
                            <div class="info">
                                <sub>webMobile</sub>
                                <p>지도기반 비상벨 모니터링 플랫폼</p>
                            </div>
                        </router-link>
                    </div>
                    <div class="pfBox">
                        <router-link to="/portfolio/view/j4fcr784pdy431v">
                            <img src="@/assets/img/pf/webmob/portfolio2.png" alt="식품 컨설팅 회사 반응형 웹사이트">
                            <div class="info">
                                <sub>webMobile</sub>
                                <p>식품 컨설팅 회사 반응형 웹사이트</p>
                            </div>
                        </router-link>
                    </div>
                    <div class="pfBox">
                        <router-link to="/portfolio/view/4wl4b2tc5q73x79">
                            <img src="@/assets/img/pf/webmob/portfolio3.png" alt="전통 문화 연구회">
                            <div class="info">
                                <sub>webMobile</sub>
                                <p>전통 문화 연구회 반응형 웹사이트</p>
                            </div>
                        </router-link>
                    </div>
                    <div class="pfBox">
                        <router-link to="/portfolio/view/mpcc0359ut9o16z">
                            <img src="@/assets/img/pf/iot/portfolio1.png" alt="관리 프로그램">
                            <div class="info">
                                <sub>IOT</sub>
                                <p>웹기반 로봇 모니터링 서비스</p>
                            </div>
                        </router-link>
                    </div>
                    <div class="pfBox">
                        <router-link to="/portfolio/view/x342g531282xc25">
                            <img src="@/assets/img/pf/iot/portfolio2.png" alt="물류 서비스">
                            <div class="info">
                                <sub>IOT</sub>
                                <p>물류 서비스 관리 시스템</p>
                            </div>
                        </router-link>
                    </div>
                    <div class="pfBox">
                        <router-link to="/portfolio/view/j266hq42o45h061">
                            <img src="@/assets/img/pf/iot/portfolio3.png" alt="벨브 리사이클링 운영 및 관리 시스템">
                            <div class="info">
                                <sub>IOT</sub>
                                <p>벨브 리사이클링 운영 및 관리 시스템</p>
                            </div>
                        </router-link>
                    </div>
                    <div class="pfBox">
                        <router-link to="/portfolio/view/5zk82o69a5o16kq">
                            <img src="@/assets/img/pf/onlinemedia/portfolio1.png" alt="클라우드 LMS서비스">
                            <div class="info">
                                <sub>LMS</sub>
                                <p>클라우드 LMS서비스</p>
                            </div>
                        </router-link>
                    </div>
                    <div class="pfBox">
                        <router-link to="/portfolio/view/k06x9359784lpeq">
                            <img src="@/assets/img/pf/onlinemedia/portfolio2.png" alt="동물보건사 교육 서비스">
                            <div class="info">
                                <sub>LMS</sub>
                                <p>동물보건사 교육 서비스</p>
                            </div>
                        </router-link>
                    </div>
                    <div class="pfBox">
                        <router-link to="/portfolio/view/40yo9fg81z29749">
                            <img src="@/assets/img/pf/software/portfolio1.png" alt="배달 매장 POS 시스템">
                            <div class="info">
                                <sub>POS</sub>
                                <p>배달 매장 POS 시스템</p>
                            </div>
                        </router-link>
                    </div>
                    <div class="pfBox">
                        <router-link to="/portfolio/view/14bgtrp2keaq5q0">
                            <img src="@/assets/img/pf/onlinemedia/portfolio6.png" alt="대한수의사회 UI">
                            <div class="info">
                                <sub>LMS</sub>
                                <p>동영상 강의 시스템</p>
                            </div>
                        </router-link>
                    </div>
                    <div class="pfBox">
                        <router-link to="/portfolio/view/2i5bsm86p8dqbu7">
                            <img src="@/assets/img/pf/onlineexhibtion/portfolio1.png" alt="부산수의사회 온라인 전시">
                            <div class="info">
                                <sub>Onmice</sub>
                                <p>부산수의사회 온라인 전시</p>
                            </div>
                        </router-link>
                    </div>
                    <div class="pfBox">
                        <router-link to="/portfolio/view/a1g4098oeur990l">
                            <img src="@/assets/img/pf/webmob/portfolio6.png" alt="운영 솔루션 FMS">
                            <div class="info">
                                <sub>webMobile</sub>
                                <p>운영 솔루션 FMS</p>
                            </div>
                        </router-link>
                    </div>
                </div>

                <div class="moreBtnBox main">
                    <router-link to="/portfolio" class="moreBtn">
                        <span>전체보기</span> <i class="pi pi-angle-right"></i>
                    </router-link>
                </div>

            </div>
        </section>

        <section class="customer_sec">
            <div class="tit">
                <h1>주요 고객사</h1>
            </div>
            <div class="content container">
                <div class="filter left"></div>
                <div class="filter right"></div>
                    <div class="logo-slider">
                        <div class="logo-track">
                            <div v-for="(logo, index) in duplicatedLogos" :key="index" class="logo-item">
                                <img :src="logo.src" alt="logo" />
                            </div>
                        </div>
                    </div>

            </div>
        </section>
    </div>
</template>

<script>
import Carousel from 'primevue/carousel';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

export default {
    name: '홈',
    data() {
         const logos = [
            { src: new URL("@/assets/img/customer/logo1.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo2.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo3.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo4.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo5.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo6.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo7.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo8.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo9.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo10.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo11.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo12.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo13.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo14.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo15.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo16.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo17.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo18.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo19.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo20.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo21.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo22.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo23.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo24.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo25.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo26.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo27.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo28.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo29.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo30.png", import.meta.url).href },
            { src: new URL("@/assets/img/customer/logo31.png", import.meta.url).href },
        ];
        return {
            bannerItems: [
                {
                    banimg: require('@/assets/img/ban1.png'),
                    tit: '홈페이지 · 웹사이트 구축 서비스&고품질 퀄리티로 성과를 가져온다',
                    txt: '웹사이트 제작에서 성과를 내는 운영까지<br/>  원스톱으로 지원합니다.'
                },
                {
                    banimg: require('@/assets/img/ban2.png'),
                    tit: '앱 제작 / 개발에 대한 아이디어를 현실로 만들어 드립니다',
                    txt: '기획/디자인/개발/운영 원스톱으로 제공 합니다.'
                },
                {
                    banimg: require('@/assets/img/ban3.png'),
                    tit: 'IoT 개발 서비스 제공을 통한 스마트한 세상을​ 위한 기술 혁신 제공',
                    txt: '우리는 IoT 기술을 기반으로 하는 시스템 통합 <br> 개발 서비스를​ 제공 합니다.'
                },
                 {
                    banimg: require('@/assets/img/ban4.png'),
                    tit: '실시간 강의 부터 VOD 학습까지 모든 것이 있습니다',
                    txt: '최고의 기술을 바탕으로 온라인 교육에 <br> 필요한 모든 시스템을 제공 합니다.'
                },
                 {
                    banimg: require('@/assets/img/ban5.png'),
                    tit: '최신 기술을 바탕으로 비즈니스에 가장 적합한 POS 및 키오스크 솔루션을 제작 합니다.',
                    txt: '고객 맞춤형 개발을 통해서 하드웨어 부터 <br> 솔루션​까지 원스톱으로 지원 합니다.'
                },
                 {
                    banimg: require('@/assets/img/ban6.png'),
                    tit: '최신 기술과 각 산업에 특화된 깊은 지식을 바탕으로 <br> 귀사의 비즈니스 최적화된 <br> 맞춤형 소프트웨어 솔루션을 제공 합니다.',
                },
            ],
            logos,
            duplicatedLogos: [...logos, ...logos] // ✅ 여기서 logos를 선언한 후 사용
        }
    },
    components: {
        Carousel,
        Tabs,
        TabList,
        Tab,
        TabPanels,
        TabPanel
    },
    methods: {
       
    }
    
}
</script>
